import { Injectable } from '@angular/core';
import { QueryBus, Wrapper } from '@skylab-angular-shared/core';
import { QuickListDataSourceBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@Wrapper(QuickListDataSourceBase)
export class QuickListDataSource {
    public constructor(
        queryBus: QueryBus
    ) { }
}
